module.exports = __webpack_public_path__ + "static/media/record.047d3a07.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/record.PNG
// module id = 568
// module chunks = 0